import * as React from 'react';
import SpaceBetween from '@amzn/awsui-components-console/space-between';
import TextFilter from '@amzn/awsui-components-console/text-filter';
import Select, { type SelectProps } from '@amzn/awsui-components-console/select';
import '../DataSourcesPage.scss';

interface TableFiltersProps {
  filteringText: string;
  selectedDataSource: SelectProps.Option | null;
  dataSourceOptions: SelectProps.Option[];
  matchCount: number;
  onFilteringTextChange: (text: string) => void;
  onDataSourceChange: (option: SelectProps.Option) => void;
}

const TableFilters: React.FC<TableFiltersProps> = ({
  filteringText,
  selectedDataSource,
  dataSourceOptions,
  matchCount,
  onFilteringTextChange,
  onDataSourceChange,
}) => {
  return (
    <SpaceBetween direction="horizontal" size="s">
      <div className="data-sources-filter__search">
        <TextFilter
          filteringPlaceholder="Find collections"
          filteringText={filteringText}
          onChange={({ detail }) => onFilteringTextChange(detail.filteringText)}
          countText={`${matchCount} ${matchCount === 1 ? 'match' : 'matches'}`}
        />
      </div>
      <div className="data-sources-filter__select">
        <Select
          selectedOption={selectedDataSource}
          onChange={({ detail }) => onDataSourceChange(detail.selectedOption)}
          options={dataSourceOptions}
          placeholder="Filter by data source"
          selectedAriaLabel="Selected"
          expandToViewport
        />
      </div>
    </SpaceBetween>
  );
};

export default TableFilters;
